export function getRulesErrorMessage(error: unknown, fallback: string) {
  const code = (error as { code?: string })?.code;

  if (code === 'permission-denied') {
    return 'Actie geweigerd door rechten. Controleer je rol of vraag de eigenaar.';
  }

  if (code === 'unauthenticated') {
    return 'Je moet ingelogd zijn om deze actie uit te voeren.';
  }

  if (code === 'failed-precondition') {
    return 'Actie geblokkeerd door voorwaarden. Controleer de entiteit en gegevens.';
  }

  if (code === 'invalid-argument') {
    return 'De ingevoerde gegevens zijn ongeldig. Controleer de velden en probeer opnieuw.';
  }

  if (code === 'already-exists') {
    return 'Deze actie is al uitgevoerd. Vernieuw de pagina om de status te controleren.';
  }

  if (code === 'not-found') {
    return 'Deze informatie is niet meer beschikbaar. Vernieuw de pagina.';
  }

  return fallback;
}
